import { ApplicationError } from '@varos/client-base';

export class NotEnoughDataError extends ApplicationError {
    constructor() {
        super('not_enough_data');
        Object.setPrototypeOf(this, NotEnoughDataError.prototype);
    }
}
